(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-category-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bb-category-tabs')) {
    customElements.define(
      'bb-category-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.select(index));
            tab.addEventListener('keydown', (event) => {
              let next = null;
              if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
              if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
              if (event.key === 'Home') next = 0;
              if (event.key === 'End') next = this.tabs.length - 1;
              if (next !== null) {
                event.preventDefault();
                this.select(next);
                this.tabs[next].focus();
              }
            });
          });
          this.onBlockSelect = (event) => {
            const index = this.tabs.findIndex((tab) => tab.dataset.blockId === event.detail.blockId);
            if (index > -1) this.select(index);
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        select(index) {
          this.tabs.forEach((tab, i) => {
            const active = i === index;
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;
            const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
            if (panel) panel.hidden = !active;
          });
          const activeTab = this.tabs[index];
          if (activeTab) activeTab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-promo-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bb-promo-popup')) {
    customElements.define(
      'bb-promo-popup',
      class extends HTMLElement {
        connectedCallback() {
          this.code = this.dataset.code;
          this.key = this.dataset.key;
          this.days = parseInt(this.dataset.days || '7', 10);
          this.dialog = this.querySelector('.bb-promo__dialog');
          this.backdrop = this.querySelector('.bb-promo__backdrop');
          this.teaser = this.querySelector('[data-open]');
          this.leaf = this.querySelector('[data-reveal]');
          this.hiddenValue = this.querySelector('[data-hidden-value]');
          this.realValue = this.querySelector('[data-real-value]');
          this.after = this.querySelector('[data-after]');
          this.copyBtn = this.querySelector('[data-copy]');
          this.copyLabel = this.querySelector('[data-copy-label]');
          this.status = this.querySelector('[data-status]');

          this.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', () => this.close()));
          this.querySelector('[data-done]').addEventListener('click', () => this.close());
          if (this.teaser) this.teaser.addEventListener('click', () => this.open());
          this.leaf.addEventListener('click', () => this.reveal());
          this.copyBtn.addEventListener('click', () => this.copy());
          this.onKey = (e) => { if (e.key === 'Escape' && this.classList.contains('is-open')) this.close(); };
          document.addEventListener('keydown', this.onKey);

          if (this.dataset.designMode === 'true') { this.open(); return; }

          const state = this.read();
          if (state && state.revealed) return;
          if (state && state.until && Date.now() < state.until) { this.showTeaser(); return; }

          const delay = Math.max(0, parseInt(this.dataset.delay || '6', 10)) * 1000;
          this.timer = setTimeout(() => this.open(), delay);
        }

        disconnectedCallback() {
          document.removeEventListener('keydown', this.onKey);
          clearTimeout(this.timer);
        }

        read() {
          try { return JSON.parse(localStorage.getItem(this.key) || 'null'); } catch (e) { return null; }
        }
        write(value) {
          try { localStorage.setItem(this.key, JSON.stringify(value)); } catch (e) {}
        }

        open() {
          this.lastFocus = document.activeElement;
          this.backdrop.hidden = false;
          this.dialog.hidden = false;
          if (this.teaser) this.teaser.hidden = true;
          requestAnimationFrame(() => {
            this.placeLeaf();
            this.classList.add('is-open');
            this.dialog.focus({ preventScroll: true });
          });
        }

        close() {
          this.classList.remove('is-open');
          setTimeout(() => { this.backdrop.hidden = true; this.dialog.hidden = true; }, 320);
          if (this.revealed) {
            this.write({ revealed: true });
          } else {
            this.write({ until: Date.now() + this.days * 86400000 });
            this.showTeaser();
          }
          if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
        }

        placeLeaf() {
          const gap = this.querySelector('[data-gap]');
          const box = this.querySelector('.bb-promo__reveal');
          if (!gap || !box || this.revealed) return;
          const g = gap.getBoundingClientRect();
          const b = box.getBoundingClientRect();
          box.style.setProperty('--leaf-x', g.left - b.left + g.width / 2 + 'px');
          box.style.setProperty('--leaf-y', g.top - b.top + g.height / 2 + 'px');
        }

        showTeaser() {
          if (this.teaser) this.teaser.hidden = false;
        }

        async reveal() {
          if (this.revealed) return;
          this.revealed = true;
          this.write({ revealed: true });
          this.leaf.classList.add('is-falling');
          setTimeout(() => {
            this.hiddenValue.hidden = true;
            this.realValue.hidden = false;
            this.after.hidden = false;
          }, 350);
          setTimeout(() => { this.leaf.hidden = true; }, 1150);

          let applied = false;
          try {
            const res = await fetch('/discount/' + encodeURIComponent(this.code) + '?redirect=/cart.js', { credentials: 'same-origin' });
            applied = res.ok;
          } catch (e) {}
          this.status.textContent = applied
            ? 'Rabat aktywny – naliczy się automatycznie w koszyku 🍂'
            : 'Wpisz kod w koszyku, aby skorzystać z rabatu.';
        }

        async copy() {
          let copied = false;
          try {
            await navigator.clipboard.writeText(this.code);
            copied = true;
          } catch (e) {
            const ta = document.createElement('textarea');
            ta.value = this.code;
            ta.setAttribute('readonly', '');
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            try { copied = document.execCommand('copy'); } catch (err) {}
            ta.remove();
          }
          this.copyBtn.classList.add('is-copied');
          this.copyLabel.textContent = copied ? 'Skopiowano ✓' : 'Zaznacz i skopiuj';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
